import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { bloquearUsuarioBy_Id, desbloquearUsuarioBy_Id } from "../api";

const UsuarioVerForm = ({ user, getUsers, setSelectedSection}) => {
  const [usuariosList, setUsuariosList] = useState([]);
  const [searchTerm, setSearchTerm] = useState(''); // Estado para la búsqueda
  const [reload, setReload] = useState(false); // Estado de recarga

  useEffect(() => {
    const userId = user;

    const fetchUsuarios = async () => {
      if (!userId) return;
      try {
        const usuariosData = await getUsers();
        const data = Array.isArray(usuariosData.data) ? usuariosData.data : [];
        
        // Filter out rows where 'fecha_eliminacion' does not meet the validation criteria
        const filteredData = data.filter(row => {
          if (!row.fecha_eliminacion) return true; // Keep row if 'fecha_eliminacion' is undefined or null
          const fechaEliminacion = row.fecha_eliminacion;
          //return fechaEliminacion === "0000-00-00 00:00:00" || fechaEliminacion === "1900-01-01 00:00:00";
          return fechaEliminacion
        });
        
        setUsuariosList(filteredData);
      } catch (error) {
        console.error("Error fetching usuarios:", error);
        setUsuariosList([]);
      }
    };

    fetchUsuarios();
  }, [user, getUsers, reload]);

  const bloquearUser = async (id) => {
    try {
      await bloquearUsuarioBy_Id(id);
      setUsuariosList(prevList => prevList.filter(usuario => usuario.id_usuario !== id));
      setReload(prev => !prev); // Cambia el estado para forzar la recarga
    } catch (error) {
      console.error("Error blocking user:", error);
    }
  };

  const desbloquearUser = async (id) => {
    try {
      await desbloquearUsuarioBy_Id(id);
      setUsuariosList(prevList => prevList.filter(usuario => usuario.id_usuario !== id));
      setReload(prev => !prev); // Cambia el estado para forzar la recarga
    } catch (error) {
      console.error("Error unblocking user:", error);
    }
  };

  const filteredUsuarios = usuariosList.filter(usuario => {
    const monthName = new Date(usuario.fecha_nacimiento).toLocaleDateString("es-ES", { month: "long" }).toLowerCase();
  
    return (
      usuario.id_usuario.toString().includes(searchTerm) || 
      usuario.pago.toString().includes(searchTerm) || 
      usuario.usuario.toString().includes(searchTerm) || 
      usuario.nombre_completo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      usuario.celular_personal.toLowerCase().includes(searchTerm) ||
      monthName.includes(searchTerm.toLowerCase()) // Filter by month
    );
  });

  
  // Función para calcular la edad basada en fecha de nacimiento
  const getEdad = (dateString) => {
    const today = new Date(); // Fecha actual
    const birthDate = new Date(dateString); // Convertir la fecha de nacimiento a un objeto Date
    let age = today.getFullYear() - birthDate.getFullYear(); // Calcular la diferencia en años
    const monthDifference = today.getMonth() - birthDate.getMonth(); // Diferencia en meses

    // Ajustar si el mes y el día de nacimiento aún no han pasado este año
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age; // Retornar la edad calculada
  };

  // Función para formatear la fecha
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
  
    // Crear fecha como UTC
    const utcDate = new Date(dateString);
  
    // Ajustar a GMT-6 (360 minutos = 6 horas)
    const localDate = new Date(utcDate.getTime() + 24 * 60 * 60 * 1000);
  
    // Formatear la fecha a 'DD-MM-YYYY'
    return localDate.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div>
      <h3>Halcones Registrados:</h3>
      
      <input 
        type="text" 
        placeholder="Buscar por ID, Nombre Completo o Alias..." 
        value={searchTerm} 
        onChange={(e) => setSearchTerm(e.target.value)} 
        style={{ padding: '5px', minWidth:"244px", marginBottom: '20px' }} 
      />

    <div className="table-container">
      <table border="1" className="table">
        <thead className="table-th">
          <tr>
            <th className="sticky-column">Halcon</th>
            <th>Usuario</th>
            <th>Nombre Completo</th>
            <th>Nombre Padrino</th>
            <th>Ultimo Pago</th>
            <th>Celular</th>
            <th>Fecha Nacimiento</th>
            <th>Edad</th>
            <th>Cant cuotas</th>
            <th>Cant Uniforme</th>
            <th>Cant Viaje</th>
            <th>Cant Maraton</th>
            <th>Cant Visita</th>
            <th>Fecha Eliminacion</th>
            <th colSpan="2">Accion</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsuarios.length > 0 ? (

            filteredUsuarios.map((usuario, index) => {
              const edad = getEdad(usuario.fecha_nacimiento);
              const rowStyle = {
              backgroundColor:
                usuario.fecha_eliminacion.trim() !== "0000-00-00 00:00:00" ? 'rgba(170, 170, 170, 1)' :
                edad < 14 ? '#cdacee' :
                usuario.pago === "cuota ene-mar 2025" ? '#c5f7d7' :
                usuario.pago === "cuota abr-jun 2025" ? '#17d4b4' :
                usuario.pago === "cuota jul-sep 2025" ? '#2a9db1' :
                usuario.pago === "cuota oct-dic 2025" ? '#3065b4' :
                usuario.pago === "cuota ene-mar 2026" ? '#ffab3dff' :
                usuario.pago === "cuota abr-jun 2026" ? '#bd7e2dff' :
                'rgba(170, 170, 170, 1)',
              };

              return (
                <tr key={index} style={rowStyle}>
                  <td className="sticky-column">
                    <button
                      className="menu-button1"
                      onClick={() =>
                        setSelectedSection({
                          section: "Pagos_especificos",
                          userId: usuario.id_usuario,
                          nombre_completo: usuario.nombre_completo,
                        })
                      }
                    >
                      {usuario.id_usuario}
                    </button>
                  </td>
                  <td>{usuario.usuario}</td>
                  <td width="200px">{usuario.nombre_completo}</td>
                  <td>{usuario.padrino}</td>
                  <td>{usuario.pago}</td>
                  <td>{usuario.celular_personal}</td>
                  <td>{formatDate(usuario.fecha_nacimiento)}</td>
                  <td>{edad}</td>
                  <td>
                    <center>{usuario.cantidad_pagada_cuotas}</center>
                  </td>
                  <td>
                    <center>{usuario.cantidad_pagada_uniforme}</center>
                  </td>
                  <td>
                    <center>{usuario.cantidad_pagada_viaje}</center>
                  </td>
                  <td>
                    <center>{usuario.cantidad_pagada_maraton}</center>
                  </td>
                  <td>
                    <center>{usuario.cantidad_pagada_visita}</center>
                  </td>
                  <td>{usuario.fecha_eliminacion}</td>
                  <td>
                    {user.tipo_usuario === "admin" && (
                      <button
                        className="menu-button2"
                        onClick={() => bloquearUser(usuario.id_usuario)}
                      >
                        Bloquear
                      </button>
                    )}
                  </td>
                  <td>
                    {user.tipo_usuario === "admin" && (
                      <button
                        className="menu-button3"
                        onClick={() => desbloquearUser(usuario.id_usuario)}
                      >
                        Desbloquear
                      </button>
                    )}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="16">No se encontraron usuarios.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>


    </div>
  );
};

UsuarioVerForm.propTypes = {
  user: PropTypes.object,
  getUsers: PropTypes.func,
  setSelectedSection: PropTypes.func,
};

export default UsuarioVerForm;
